import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { AgGridReact } from 'ag-grid-react';
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Card, Flex, Grid, GridItem, Heading } from '@chakra-ui/react';
import admin from '../../../api/admin';
import { GetProjectMediaResponse } from '../../../models/admin-api/dto';
import DocViewer, { DocViewerRenderers, IDocument } from "react-doc-viewer";
import { useBuilderStore } from '../../../contexts/RootStoreProvider';
import { observer } from 'mobx-react';
import AssetFileUploader from '../../assetFileUploader';
import { getFileExtension } from '../../../helpers/sasKeyHelper';


const AssetAttachmentList = (props: any) => {


    const [isLoading, setIsLoading] = React.useState(false);
    const [assetMedia, setAssetMedia] = React.useState([]);
    const [selectedMediaUrl, setSelectedMediaUrl] = React.useState<IDocument[]>([]);
    const [viewer, setViewer] = React.useState<string>("DocViewer");

    const colDefs = [
        { headerName: "Name", field: "name", flex: 2 },
        { headerName: "Type", field: "type", flex: 1, enableRowGroup: true },
    ];


    const switchViewer = (selectedMediaUrl) => {
        const ext = getFileExtension(selectedMediaUrl);

        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'tiff', 'docx'];

        if (imageExtensions.includes(ext)) {
            setViewer("DocViewer")
        }
        else {
            setViewer("Native")
        }

    }

    const handleOnSelectAsset = (e: any) => {

        if (e) {
            console.log(e);
            var assetImage = [{ uri: e.data.url }];
            setSelectedMediaUrl(assetImage)
            switchViewer(e.data.url);
        }
        else {
            setSelectedMediaUrl([])
        }
    }

    const getAssetmedia = (assetId: number) => {
        setIsLoading(true);
        admin.Assets.GetAssetMedia(assetId).then(
            (res: GetProjectMediaResponse) => {
                setAssetMedia(res.result);
                setIsLoading(false);
            },
            (error) => {
                alert('Error Retrieving Asset Media!' + error);
                setIsLoading(false);
            }
        );


    }

    useEffect(() => {

        if (props.assetId !== undefined) {
            getAssetmedia(props.assetId);
        }
        else {
            alert("Missing Asset ID!")
        }
    }
        , [props.assetId]);

    return (
        <>

            <Accordion defaultIndex={0}>
                <AccordionItem  >
                    <h2>
                        <AccordionButton>
                            <Box as='span' flex='1' textAlign='left'>
                                <Heading as='h3' color='blue.600' size='sm'>Attachments</Heading>
                            </Box>
                            <AccordionIcon />
                        </AccordionButton>
                    </h2>
                    <AccordionPanel pb={4}>
                        <Grid templateColumns="repeat(3, 1fr)" gap="1">
                            <GridItem height={500} colSpan={1.5} padding={0} >
                                <div
                                    className="ag-theme-quartz" // applying the grid theme
                                    style={{ height: 500 }} // the grid will fill the size of the parent container
                                >
                                    <AgGridReact
                                        rowData={assetMedia}
                                        columnDefs={colDefs as any}
                                        onRowClicked={handleOnSelectAsset}
                                        rowSelection={'single'}
                                    />
                                </div>
                            </GridItem>
                            {selectedMediaUrl && selectedMediaUrl[0] ?
                                <GridItem colSpan={2} height={500} >

                                    {viewer == "DocViewer" ? (
                                        <>
                                            <DocViewer config={{
                                                header: {
                                                    disableHeader: true,
                                                    disableFileName: true,
                                                    retainURLParams: false
                                                }
                                            }} pluginRenderers={DocViewerRenderers} documents={selectedMediaUrl} />
                                        </>
                                    ) : (

                                        <iframe src={selectedMediaUrl[0]?.uri!} style={{ width: "100%", height: 500, border: "none", display: isLoading ? "none" : "block" }} title="Document Preview" />

                                    )}

                                    <>





                                    </>
                                </GridItem> : <></>}
                        </Grid>
                    </AccordionPanel>
                </AccordionItem>

                {props.showUpload ? (<>

                    <AccordionItem>
                        <h2>
                            <AccordionButton>
                                <Box as='span' flex='1' textAlign='left'>
                                    <Heading as='h3' color='blue.600' size='sm'>Upload</Heading>
                                </Box>
                                <AccordionIcon />
                            </AccordionButton>
                        </h2>
                        <AccordionPanel pb={4}>
                            <AssetFileUploader userId={props.userId} assetId={props.assetId} refreshItems={() => getAssetmedia(props.assetId)} projectId={props.projectId} />

                        </AccordionPanel>
                    </AccordionItem>
                </>) : (<></>)}
            </Accordion>


        </>
    )
}

AssetAttachmentList.propTypes = {
    assetId: PropTypes.any,
    showUpload: PropTypes.any,
    projectId: PropTypes.any
}

export default observer(AssetAttachmentList)